import { gql } from "@apollo/client";

export const CREATE_NEWS_GENERATION_RECORD_MUTATION = gql`
  mutation CreateNewsArticle($input: NewsArticleInput!) {
    createNewsArticle(input: $input) {
      success
      messageId
      error
    }
  }
`;
